<template>
  <div class="bg-gray-900 rounded-lg p-2">
    <router-link class="flex justify-between" :to="`/management/chart/location?month=${this.month}`">
      <h1 class="text-gray-300 text-sm">محل سفارش</h1>
      <ExternalLinkIcon class="h-5 w-5 text-yellow-500"/>
    </router-link>
    <div class="flex justify-center">
      <LoadingSpinner class="h-10 w-10 text-yellow-500/80 my-8" v-if="loading"/>
      <apexchart class="" type="donut" :options="options" :series="series" v-else-if="this.series.length"/>
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>

<script>
import {getLocationTypeReport} from "../../API/API";
import LoadingSpinner from "../General/LoadingSpinner";
import {ExternalLinkIcon} from "@heroicons/vue/outline";

export default {
  name: "LocationTypeChart",
  components: {LoadingSpinner, ExternalLinkIcon},
  props: ['month', 'day'],
  data() {
    return {
      loading: true,
      series: [],
      options: {
        fontFamily: 'iransans',
        labels: [],
        colors: ['#ef4444', '#be123c', '#9C27B0'],
        dataLabels: {
          style: {
            colors: ['#e5e5e5']
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
              }
            }
          }
        },
        stroke: {
          show: false,
        },
        legend: {
          show: false,
        }
      },
    }

  },
  created() {
    this.getReports()
  },
  methods: {
    getReports() {
      this.series = []
      this.options.labels = []
      this.loading = true
      getLocationTypeReport('month', 'qty', '', this.month, this.day)
          .then(resp => {
            resp.data.result.yaxis.forEach((item) => {
              this.options.labels.push(item.name)
              if (item.data.length) {
                this.series.push(item.data[0])
              }
            })
            this.loading = false
          })
    }
  },
  watch: {
    day() {
      if (this.day !== '')
        this.getReports()
    },
    month() {
      this.getReports()
    }
  }
}
</script>

<style scoped>

</style>